<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <h1>
            <v-icon x-large color='error' left>mdi-cancel</v-icon>
            Access denied
          </h1>
          Unfortunately you do not have access to this area. If you believe you should have access to this area, please contact
          the office to have your permissions adjusted.
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'no-access',
  mounted () {
    this.$store.dispatch('clearSubnav')
  }
}
</script>
